import Vue from 'vue'
import { Button,Dialog,Timeline,TimelineItem,Card,Pagination,Input,Popover,Rate,Row,Col  } from 'element-ui'; // Form,FormItem,
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Popover)
Vue.use(Rate)
Vue.use(Row)
Vue.use(Col)




// WEBPACK FOOTER //
// ./src/plugins/element.js